require('./lbCardIcon.scss');

const lbCardIcon = angular.module('app.lbCardIcon', []);

lbCardIcon.component('lbCardIcon', {
  bindings: {
    cardType: '<',
  },
  controllerAs: 'vm',
  controller: [controller],
  template: `<i class="lbCardIcon_{{ vm.cardType }}"></i>`,
});

function controller() {
  let vm = this;
}

export default lbCardIcon;



// WEBPACK FOOTER //
// ./src/components/lbCardIcon/lbCardIcon.js